module.exports = __webpack_public_path__ + "img/posy.684b9b64.jpg";